import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=f2644e80&scoped=true&"
import script from "./FilterList.vue?vue&type=script&lang=js&"
export * from "./FilterList.vue?vue&type=script&lang=js&"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=f2644e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2644e80",
  null
  
)

export default component.exports